<template>
  <Modal title="Fjern afdeling fra organisation?">
    <ModalCloseButton :to="{ name: 'OrganizationsEdit' }" />
    <div class="form">
      <button v-if="isSaving" class="button--save">
        {{ t('organization.edit.tabs.departments.destroy.deleting') }}
      </button>
      <button v-else class="button--save" @click="handleSubmit()">
        {{ t('organization.edit.tabs.departments.destroy.remove') }}
      </button>
    </div>
  </Modal>
</template>

<script>
import { ref, onMounted } from 'vue'
import { useStore } from 'vuex'
import { useRoute } from 'vue-router'
import { useI18n } from '@/composables/useI18n'
import Modal from '@/components/Modal'
import ModalCloseButton from '@/components/ModalCloseButton'
import router from '@/routes'

export default {
  name: 'DepartmentsDelete',
  components: { Modal, ModalCloseButton },
  setup() {
    const store = useStore()
    const route = useRoute()
    const { t } = useI18n()

    const isSaving = ref(false)

    const handleSubmit = () => {
      isSaving.value = true
      store
        .dispatch('deleteDepartment', route.params.id)
        .then(() => {
          isSaving.value = false
          router.push({ name: 'OrganizationsEdit' })
          store.dispatch('showFlashMessage', {
            message:
              t('flash_messages.department') +
              t('flash_messages.delete.success'),
          })
        })
        .catch(() => {
          isSaving.value = false
          store.dispatch('showFlashMessage', {
            message:
              t('flash_messages.department') + t('flash_messages.delete.error'),
          })
        })
    }

    onMounted(() => {
      store.dispatch('collapseSidebar')
    })

    return {
      isSaving,
      handleSubmit,
    }
  },
}
</script>
